import * as yup from "yup";

const reportSchema = yup.object().shape({
  detail: yup.string().required("Please enter your concerns"),
  reportOptions: yup.string().required("Please submit your concern"),
});

export { reportSchema };
